import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getSalesOrderDetail } from "./actions";
import Step1 from "./Steps/step1";
import Step2 from "./Steps/step2";
import Step3 from "./Steps/step3";
import Step4 from "./Steps/step4";
import Sidebar from "../../components/global/Sidebar";
import Content from "../../components/dashboard/general/Content";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import LoadingOverlay from "./Components/Loading/LoadingOverlay";

const { URL_PREFIX } = window;

class VF1Wizard extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: false,
    };
  }

  async componentWillMount() {
    try {
      this.setState({ loading: true });

      await this.props.getSalesOrderDetail();

    } catch (error) {

    } finally {
      this.setState({ loading: false });
    }
  }

  render() {
    const { soDetail } = this.props.vf1;
    if (!soDetail?.Id) {
      return (
        <p className="text-center">
          <i className="fa fa-circle-notch fa-spin fa-4x loading" />
        </p>
      );
    }

    return (
      <>
        <LoadingOverlay
          isLoading={this.state.loading}
        />
        <Router>
          <Sidebar soDetail={soDetail} />
          <Content style={{ backgroundColor: "White" }}>
            <Switch>
              <Route
                path={`${URL_PREFIX}/vf1/wizard`}
                component={Step1}
                exact
              />
              <Route
                path={`${URL_PREFIX}/vf1/wizard/guest-allocation`}
                component={Step2}
                exact
              />
              <Route
                path={`${URL_PREFIX}/vf1/wizard/confirmation`}
                component={Step3}
                exact
              />
              <Route
                path={`${URL_PREFIX}/vf1/wizard/summary`}
                component={Step4}
                exact
              />
            </Switch>
          </Content>
        </Router >
      </>
    );
  }
}

VF1Wizard.propTypes = {
  getSalesOrderDetail: PropTypes.func.isRequired,
  vf1: PropTypes.object.isRequired,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSalesOrderDetail,
    },
    dispatch
  );

const mapStateToProps = (state) => ({
  vf1: state.vf1,
});

export default connect(mapStateToProps, mapDispatchToProps)(VF1Wizard);
